import { Injectable } from "@angular/core";
import { environment } from "../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { LancamentosDeCaixa, LancamentoCaixaResponse } from "../models/lancamentosDeCaixa.model";
import { catchError, Observable, tap, throwError, map } from "rxjs";
import { LancamentoCaixaEnum } from "../models/enums/lancamentoDeCaixaEnum";

@Injectable({
    providedIn: 'root',
})
export class LancamentosDeCaixaService {
    private apiUrl = `${environment.advContabilApi}/api/lancamentoCaixa`;

    constructor(private http: HttpClient) { }

    criarLancamentoDeCaixa(lancamentoCaixa: LancamentosDeCaixa): Observable<any> {
        return this.http.post<LancamentosDeCaixa>(`${this.apiUrl}/inserir`, lancamentoCaixa);
    }

    editarLancamentoCaixa(lancamentoCaixa: any): Observable<any> {
        return this.http.put<any>(`${this.apiUrl}/atualizar`, lancamentoCaixa);
    }

    listaLancamentosDeCaixa(usuarioId: string): Observable<LancamentosDeCaixa[]> {
        const params = new HttpParams().set('usuarioId', usuarioId);
        
        return this.http.get<LancamentoCaixaResponse[]>(`${this.apiUrl}/listar`, { params })
            .pipe(
                map(response => {
                    return response.map(item => ({
                        Id: item.id,
                        Periodo: item.periodo,
                        Valor: item.valor,
                        Descricao: item.descricao,
                        ContaContabilId: item.contaContabilId,
                        Tipo: item.tipo,
                        UsuarioId: item.usuarioId
                    }));
                })
            );
    }
    

    listaTipoLancamentoPreenchido(tipoLancamento: LancamentoCaixaEnum): Observable<LancamentosDeCaixa[]> {
        const params = new HttpParams().set('tipoLancamento', tipoLancamento);
        return this.http.get<LancamentosDeCaixa[]>(`${this.apiUrl}/lancamentoTipoLancamentoPreenchido`, { params });
    }

    deleteLancamentoCaixa(id: any): Observable<any> {
        return this.http.delete<any>(`${this.apiUrl}/Deletar/${id}`).pipe(
            tap((resposta) => {
            }),
            catchError((error) => {
                console.error('Erro ao deletar lançamento caixa', error);
                return throwError(() => new Error('Falha ao deletar lançamento caixa'));
            })
        );
    }
}
